package one.healthium.log_weight.ui.internal

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import loco.GENERAL_SAVE
import loco.UPDATE_WEIGHT_INFO_LABEL
import loco.UPDATE_WEIGHT_SCREEN_TITLE
import one.healthium.profile.ui.weight.WeightPicker
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.components.AppProgressButton
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black50
import one.healthium.ui.compose.theme.gray_3
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
internal fun LogWeightControl(
    uiModel: WeightUiModel,
    isMetric: Boolean,
    saveInProgress: Boolean,
    onSaveClicked: (Float) -> Unit,
) {
    val currentWeight = remember { mutableStateOf(uiModel.currentWeight) }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .verticalScroll(rememberScrollState()),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Icon(
            modifier = Modifier.size(46.dp),
            painter = painterResource(AppIcons.icFileChecked),
            tint = black50,
            contentDescription = null,
        )
        Spacer(Modifier.height(16.dp))
        Text(
            modifier = Modifier.padding(horizontal = 30.dp),
            text = stringResource(loco.Res.string.UPDATE_WEIGHT_SCREEN_TITLE),
            style = AppTheme.logWeightControlStyle?.titleStyle ?: AppTheme.textStyles.secondary_30_500,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(16.dp))
        Text(
            modifier = Modifier.padding(horizontal = 30.dp),
            text = stringResource(loco.Res.string.UPDATE_WEIGHT_INFO_LABEL),
            style = AppTheme.textStyles.secondary_14_400,
            color = gray_3,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(30.dp))
        WeightPicker(
            currentWeight = uiModel.currentWeight,
            isMetric = isMetric,
            onWeightChanged = {
                currentWeight.value = it
            }
        )
        Spacer(Modifier.height(30.dp))
        AppProgressButton(
            modifier = Modifier.defaultMinSize(minWidth = 176.dp).testTag("log_weight_save"),
            onClick = {
                onSaveClicked(currentWeight.value)
            },
            loading = saveInProgress,
            text = stringResource(loco.Res.string.GENERAL_SAVE),
        )
        Spacer(Modifier.height(50.dp))
    }
}
